import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "antd/dist/reset.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider, Layout } from "antd";
const { Sider } = Layout;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#de0312 ",
        },
        components: {
          Layout: { colorBgLayout: "#fff" },
          Menu: {
            controlItemBgActive: "#FFE6D6",
            colorPrimaryActive: "#FFE6D6",
          },
          Card: {
            colorPrimary: "#FFF6F1",
          },
          Statistic: {
            colorTextDescription: "#FF6263",
          },
          Form: {
            colorPrimary: "blue",
            colorBorder: "green",
            controlOutline: "green",
          },
          Input: {
            //colorBorder: "green",
            colorPrimary: "#FFCC29",
            colorPrimaryHover: "#FFCC29",
          },
          Select: {
            colorPrimary: "#FFCC29",
            colorPrimaryHover: "#FFCC29",
          },
          Radio: {
            colorPrimary: "#FFCC29",
            colorPrimaryHover: "#FFCC29",
          },
          DatePicker: {
            colorPrimary: "#FFCC29",
            colorPrimaryHover: "#FFCC29",
          },
          Upload: {
            colorPrimary: "#FFCC29",
            colorPrimaryHover: "#FFCC29",
          },
        },
      }}
    >
      <Router>
        <App />
      </Router>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
